import { render, staticRenderFns } from "./ReferralCard.vue?vue&type=template&id=1e1da43a&scoped=true&"
import script from "./ReferralCard.vue?vue&type=script&lang=js&"
export * from "./ReferralCard.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCard.vue?vue&type=style&index=0&id=1e1da43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1da43a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
